/** PC 顶栏频道导航 */
export const NAV_CHANNEL_LINKS = [
  {
    key: 'recommended',
    to: '/explore',
    labelKey: 'nav.channelRecommended',
    icon: 'forYou',
  },
  {
    key: 'sport',
    to: '/sport',
    labelKey: 'nav.sport',
    icon: 'sport',
  },
  {
    key: 'crypto',
    to: '/crypto',
    labelKey: 'nav.crypto',
    icon: 'crypto',
  },
  {
    key: 'leagues',
    to: '/leagues',
    labelKey: 'nav.leagues',
    icon: 'leagues',
  },
  {
    key: 'invite',
    to: '/referrals',
    labelKey: 'nav.invite',
    icon: 'invite',
  },
];
